import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Label = styled.label`
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  color: ${tokens.colors.black};
  margin: 0;
  margin-bottom: ${tokens.space.smallest};
  display: block;
`;
